import { func, node, shape } from 'prop-types';
import React, { createContext, PureComponent } from 'react';

import { C, readingTime as readTime, SHAPE } from '../../common';
import { ENV } from '../../reactor/common';
import PKG from '../../../package.json';

const pkg = { name: PKG.name, version: PKG.version };
const TWO_MINUTES = 120 * 1000;
let timeoutSummary;

const {
  AMPLITUDE: {
    EVENT_SECTION, ON_CLOSE, ON_END_OF_STORY, SUMMARY_STORY, VIEW_STORY, VIEWING_GAP,
  },
  PAGE_TYPE: { FOOTER },
} = C;
const { IS_WEB, IS_SERVER } = ENV;
const Context = createContext();
const { Provider, Consumer: ConsumerAmplitude } = Context;

class ProviderAmplitude extends PureComponent {
  constructor(props) {
    super(props);

    if (IS_WEB && !IS_SERVER) {
      window.addEventListener('beforeunload', this.onClose);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) timeoutSummary = setTimeout(this.onClose, TWO_MINUTES);
        else clearTimeout(timeoutSummary);
      });
    }

    this.state = {
      currentIndex: undefined,
      pages: undefined,
      summary: false,
    };
  }

  componentWillReceiveProps({ story: nextStory = { } }) {
    const { onLogEvent, props: { story = {} } } = this;
    if (nextStory.id && story.id !== nextStory.id) {
      const { pages = [], sponsored, id } = nextStory;

      onLogEvent(VIEW_STORY, { list_id: id, sponsored, total_cards: pages.length });
      this.setState({
        currentIndex: undefined,
        pages: pages.map(page => ({ readingTime: readTime({ pages: [page] }).seconds })),
        summary: false,
      });
    }
  }

  onLogEvent = (type, { index, ...props } = {}) => {
    const {
      props: { logEvent, story: { id, pages = [] } = {} },
      state: { currentIndex },
    } = this;
    const page = pages[index || currentIndex];

    logEvent({
      type,
      list_id: id,
      section: EVENT_SECTION,
      ...(page
        ? {
          card_num: (index || currentIndex) + 1,
          card_type: page.type,
          picture_included: page.image !== undefined || page.images !== undefined,
          video_included: page.video !== undefined,
          button_included: page.link !== undefined,
          pkg,
        }
        : { pkg }
      ),
      ...props,
    });
  }

  onLogScroll = (pagesVisibility = []) => {
    const { onClose, props: { story }, state: { pages = [] } } = this;
    let { state: { currentIndex } } = this;

    pagesVisibility.forEach((visibility, index) => {
      const page = pages[index] || {};
      let { viewingTime = 0, viewingStart } = page;

      // Dispatch summary
      if (story.pages[index].type === FOOTER && visibility > 0) onClose(ON_END_OF_STORY);

      // Determine page visibility and dispatch event of already viewed pages.
      if (visibility >= VIEWING_GAP && !viewingStart) {
        currentIndex = index;
        if (!viewingStart) viewingStart = new Date();
      } else if (visibility < VIEWING_GAP && viewingStart) {
        viewingTime += Math.round((new Date() - viewingStart) / 1000);
        viewingStart = undefined;
      }

      pages[index] = {
        ...page, viewingTime, viewingStart,
      };
    });

    this.setState({ currentIndex, pages });
  }

  onClose = (dispatcher = ON_CLOSE) => {
    const { onLogEvent, state: { pages = [], summary } } = this;

    if (summary) return;
    const props = { dispatcher, expended_time: 0, expected_time: 0 };
    pages.forEach(({ readingTime = 0, viewingTime = 0 }, i) => {
      props[`interest_card_${i + 1}`] = readingTime > 0 ? parseInt((viewingTime / readingTime) * 100, 10) : 0;
      props.expended_time += viewingTime;
      props.expected_time += readingTime;
    });
    onLogEvent(SUMMARY_STORY, props);
    this.setState({ summary: true });
  }

  render() {
    const {
      onClose, onLogEvent, onLogScroll, props: { children },
    } = this;

    return (
      <Provider value={{ logEvent: onLogEvent, logScroll: onLogScroll, onClose }}>
        { children }
      </Provider>
    );
  }
}

ProviderAmplitude.propTypes = {
  children: node,
  logEvent: func,
  story: shape(SHAPE.STORY),
};

ProviderAmplitude.defaultProps = {
  children: undefined,
  logEvent() {},
  story: undefined,
};

export { ConsumerAmplitude, ProviderAmplitude };
